// // CoinleyModal.jsx 
// import React, { useState, useEffect, useRef } from 'react';
// import PaymentMethods from './PaymentMethods';
// import PaymentStatus from './PaymentStatus';
// import QRCode from './QRCode';
// import { WALLET_TYPES, getWalletInstallUrl, detectWallets, debugWalletEnvironment } from '../services/walletService';
// import logo from '../assets/Logomark.png';

// // Wallet Dropdown Component - Updated with Phantom
// const WalletDropdown = ({
//   supportedWallets,
//   availableWallets,
//   walletConnection,
//   onConnectWallet,
//   getWalletDisplayName,
//   getWalletIcon,
//   theme
// }) => {
//   const [walletDropdownOpen, setWalletDropdownOpen] = useState(false);
//   const walletDropdownRef = useRef(null);

//   // Close dropdown on outside click
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (walletDropdownRef.current && !walletDropdownRef.current.contains(event.target)) {
//         setWalletDropdownOpen(false);
//       }
//     }
//     if (walletDropdownOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     } else {
//       document.removeEventListener('mousedown', handleClickOutside);
//     }
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [walletDropdownOpen]);

//   // Sort wallets: connected first, then detected, then others
//   const sortedWallets = [...supportedWallets].sort((a, b) => {
//     const aConnected = walletConnection?.walletType === a;
//     const bConnected = walletConnection?.walletType === b;
//     const aDetected = availableWallets[a];
//     const bDetected = availableWallets[b];

//     if (aConnected && !bConnected) return -1;
//     if (bConnected && !aConnected) return 1;
//     if (aDetected && !bDetected) return -1;
//     if (bDetected && !aDetected) return 1;
//     return 0;
//   });

//   const getWalletStatus = (walletType) => {
//     const isConnected = walletConnection?.walletType === walletType;
//     const isDetected = availableWallets[walletType];

//     if (isConnected) return { text: 'Connected', color: 'green' };
//     if (isDetected) return { text: 'Detected', color: 'blue' };
//     return { text: 'Not Installed', color: 'gray' };
//   };

//   const getSelectedWalletDisplay = () => {
//     if (walletConnection) {
//       const status = getWalletStatus(walletConnection.walletType);
//       return (
//         <div className="flex items-center gap-3">
//           <img
//             src={getWalletIcon(walletConnection.walletType)}
//             alt={getWalletDisplayName(walletConnection.walletType)}
//             className="h-8 w-8"
//             onError={(e) => { e.target.style.display = 'none'; }}
//           />
//           <div className="flex flex-col">
//             <span className="text-base font-normal">{getWalletDisplayName(walletConnection.walletType)}</span>
//             <span className={`text-xs ${status.color === 'green' ? 'text-green-600' :
//                 status.color === 'blue' ? 'text-blue-600' : 'text-gray-500'
//               }`}>
//               {status.text}
//             </span>
//           </div>
//         </div>
//       );
//     }

//     // Show first detected wallet as default suggestion
//     const firstDetected = sortedWallets.find(wallet => availableWallets[wallet]);
//     if (firstDetected) {
//       return (
//         <div className="flex items-center gap-3">
//           <img
//             src={getWalletIcon(firstDetected)}
//             alt={getWalletDisplayName(firstDetected)}
//             className="h-8 w-8"
//             onError={(e) => { e.target.style.display = 'none'; }}
//           />
//           <span className="text-gray-500">Select {getWalletDisplayName(firstDetected)}...</span>
//         </div>
//       );
//     }

//     return <span className="text-gray-500">Choose a wallet...</span>;
//   };

//   return (
//     <div className="px-4">
//       <label className="block text-sm font-medium mb-2 text-gray-700">
//         Select Wallet
//       </label>

//       <div className="relative" ref={walletDropdownRef}>
//         <button
//           type="button"
//           className="w-full flex items-center justify-between py-4 bg-white rounded-2xl shadow border border-gray-200 text-gray-900 text-base font-normal focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50 transition"
//           onClick={() => setWalletDropdownOpen((open) => !open)}
//           style={{ minHeight: '56px', padding: '0.5rem' }}
//         >
//           {getSelectedWalletDisplay()}
//           <svg className={`w-5 h-5 ml-2 transition-transform ${walletDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//           </svg>
//         </button>

//         {walletDropdownOpen && (
//           <div className="absolute left-0 mt-2 px-2 w-full bg-white rounded-2xl shadow-lg border border-gray-100 z-20" style={{ minWidth: '100%' }}>
//             {sortedWallets.map((walletType) => {
//               const isConnected = walletConnection?.walletType === walletType;
//               const isDetected = availableWallets[walletType];
//               const status = getWalletStatus(walletType);

//               return (
//                 <div
//                   key={walletType}
//                   className={`flex items-center justify-between mt-1 mb-1 px-2 py-3 rounded-2xl transition ${isConnected ? 'bg-green-50' :
//                       isDetected ? 'hover:bg-gray-100 cursor-pointer' :
//                         'opacity-60 cursor-not-allowed'
//                     }`}
//                   style={{ minHeight: '56px' }}
//                   onClick={() => {
//                     if (isDetected && !isConnected) {
//                       setWalletDropdownOpen(false);
//                       onConnectWallet(walletType);
//                     }
//                   }}
//                 >
//                   <div className="flex items-center gap-3">
//                     <img
//                       src={getWalletIcon(walletType)}
//                       alt={getWalletDisplayName(walletType)}
//                       className="h-8 w-8"
//                       onError={(e) => { e.target.style.display = 'none'; }}
//                     />
//                     <div className="flex flex-col">
//                       <span className={`text-base font-normal ${isConnected ? 'text-green-800' : 'text-gray-900'
//                         }`}>
//                         {getWalletDisplayName(walletType)}
//                       </span>
//                       <span className={`text-xs ${status.color === 'green' ? 'text-green-600' :
//                           status.color === 'blue' ? 'text-blue-600' : 'text-gray-500'
//                         }`}>
//                         {status.text}
//                       </span>
//                     </div>
//                   </div>

//                   <div className="flex items-center">
//                     {isConnected ? (
//                       <div className="flex items-center space-x-2">
//                         <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
//                         <span className="text-xs text-green-600 font-medium">Ready</span>
//                       </div>
//                     ) : isDetected ? (
//                       <span className="text-xs text-blue-600 font-medium">Click to connect</span>
//                     ) : (
//                       <a
//                         href={getWalletInstallUrl(walletType)}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="text-xs text-gray-500 hover:text-gray-700 underline"
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         Install
//                       </a>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // NEW: Screen transition wrapper component
// const ScreenTransition = ({
//   currentStep,
//   targetStep,
//   children,
//   className = "",
//   duration = 300
// }) => {
//   const [isVisible, setIsVisible] = useState(currentStep === targetStep);
//   const [shouldRender, setShouldRender] = useState(currentStep === targetStep);

//   useEffect(() => {
//     if (currentStep === targetStep) {
//       // Show the screen
//       setShouldRender(true);
//       // Small delay to ensure DOM is ready, then trigger animation
//       setTimeout(() => setIsVisible(true), 10);
//     } else {
//       // Hide the screen
//       setIsVisible(false);
//       // Remove from DOM after animation completes
//       setTimeout(() => setShouldRender(false), duration);
//     }
//   }, [currentStep, targetStep, duration]);

//   if (!shouldRender) return null;

//   return (
//     <div
//       className={`
//         transition-all duration-300 ease-out
//         ${isVisible
//           ? 'transform translate-y-0 opacity-100'
//           : 'transform translate-y-full opacity-0'
//         }
//         ${className}
//       `}
//       style={{
//         transitionDuration: `${duration}ms`
//       }}
//     >
//       {children}
//     </div>
//   );
// };

// const CoinleyModal = ({
//   isOpen,
//   onClose,
//   payment,
//   paymentStatus,
//   selectedPaymentMethod,
//   onPaymentMethodSelect,
//   onPayment,
//   onBack,
//   error,
//   theme = 'light',
//   merchantName,
//   transactionHash,
//   walletConnection,
//   onConnectWallet,
//   testMode = false,
//   supportedNetworks = [],
//   availableWallets = {},
//   supportedWallets = [],
//   step = 'select-currency',
//   merchantWalletAddresses = {},
//   debug = false,
//   processingStartTime = null,
//   pendingBackendConfirmation = false,
//   paymentNetwork = null,
//   merchantFeePercentage = 0.0175
// }) => {
//   const [paymentType, setPaymentType] = useState('wallet');

//   // Debug payment data
//   useEffect(() => {
//     if (payment && debug) {
//       console.log('CoinleyModal - Payment data:', {
//         amount: payment.amount,
//         feeAmount: payment.feeAmount,
//         totalAmount: payment.totalAmount,
//         feeChargedTo: payment.feeChargedTo,
//         originalAmount: payment.originalAmount,
//         merchantFeePercentage: merchantFeePercentage,
//         dynamicFeeDisplay: `${(merchantFeePercentage * 100).toFixed(2)}%`
//       });
//     }
//   }, [payment, debug, merchantFeePercentage]);

//   // Get wallet address for current network
//   const getWalletAddressForNetwork = () => {
//     if (!selectedPaymentMethod) return 'No network selected';

//     const networkAddress = merchantWalletAddresses[selectedPaymentMethod.network];
//     if (networkAddress) {
//       return networkAddress;
//     }

//     if (payment?.recipientWallet) {
//       return payment.recipientWallet;
//     }

//     return 'No wallet address configured for this network';
//   };

//   // Handle close for success screen
//   const handleSuccessClose = () => {
//     console.log("Success screen close button clicked");
//     if (onClose) {
//       onClose();
//     }
//   };

//   // Utility functions
//   const formatAmount = (amount) => {
//     return parseFloat(amount).toFixed(2);
//   };

//   const formatTransactionHash = (hash) => {
//     if (!hash) return '';
//     if (hash.length <= 14) return hash;
//     return `${hash.slice(0, 8)}...${hash.slice(-6)}`;
//   };

//   const getNetworkDisplayName = (network) => {
//     const names = {
//       ethereum: 'Ethereum',
//       bsc: 'BSC',
//       tron: 'Tron',
//       algorand: 'Algorand',
//       solana: 'Solana'
//     };
//     return names[network] || network;
//   };

//   // Updated wallet display names with Phantom
//   const getWalletDisplayName = (walletType) => {
//     const names = {
//       [WALLET_TYPES.METAMASK]: 'MetaMask',
//       [WALLET_TYPES.TRONLINK]: 'TronLink',
//       [WALLET_TYPES.TRUST_WALLET]: 'Trust Wallet',
//       [WALLET_TYPES.LUTE]: 'Lute Wallet',
//       [WALLET_TYPES.PHANTOM]: 'Phantom'
//     };
//     return names[walletType] || walletType;
//   };

//   // Updated wallet icons with Phantom
//   const getWalletIcon = (walletType) => {
//     const icons = {
//       [WALLET_TYPES.METAMASK]: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3ymr3UNKopfI0NmUY95Dr-0589vG-91KuAA&s',
//       [WALLET_TYPES.TRONLINK]: 'https://www.tronlink.org/images/logo.png',
//       [WALLET_TYPES.TRUST_WALLET]: 'https://trustwallet.com/assets/images/trust_logotype.svg',
//       [WALLET_TYPES.LUTE]: 'https://lute.app/logo.png',
//       [WALLET_TYPES.PHANTOM]: 'https://phantom.app/img/phantom-logo.png'
//     };
//     return icons[walletType] || '';
//   };

//   // Helper to format the dynamic fee percentage
//   const formatFeePercentage = () => {
//     return (merchantFeePercentage * 100).toFixed(2);
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50">
//       <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} aria-hidden="true" />
//       <div className="fixed inset-0 overflow-y-auto">
//         <div className="flex min-h-screen items-center justify-center p-4">
//           <div className="coinley-modal relative pt-6 w-full max-w-md mx-auto shadow-xl bg-gray-100 rounded-3xl overflow-hidden">
//             {/* Header with Logo */}
//             <div className="bg-white flex justify-between items-center mb-6 mr-3 ml-3 py-4 px-2 rounded-full">
//               <div className="flex-1 flex items-center gap-2 px-4">
//                 <img src={logo} className="w-auto h-auto" alt="Coinley Logo" />
//                 <span className="text-lg font-semibold text-gray-800">Payment Details</span>
//               </div>
//               {step !== 'success' && step !== 'processing' && (
//                 <button
//                   onClick={onClose}
//                   className="text-gray-500 hover:text-gray-700 focus:outline-none"
//                 >
//                   <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               )}
//             </div>

//             {/* Payment Summary */}
//             {payment && step !== 'success' && (
//               <div className="mb-6">
//                 <div className="text-center">
//                   <div className="text-sm text-gray-600">
//                     Total Amount
//                   </div>
//                   <div className="coinley-amount-display text-3xl md:text-9xl lg:text-9xl font-bold text-[#7042D2] mt-2 leading-tight tracking-tight">
//                     ${formatAmount(payment.totalAmount || payment.amount)}
//                   </div>

//                   {/* Show fee breakdown with dynamic percentage */}
//                   {payment.feeChargedTo === 'customer' && payment.feeAmount > 0 && (
//                     <div className="mt-2 text-sm text-gray-500">
//                       {/* Fee details removed for cleaner UI */}
//                     </div>
//                   )}

//                   {/* Show different message when merchant pays fees */}
//                   {payment.feeChargedTo === 'merchant' && (
//                     <div className="mt-2 text-sm text-gray-500">
//                       No additional fees
//                     </div>
//                   )}

//                   <div className="text-sm text-gray-600 mt-4">Payment to:</div>
//                   <div className="coinley-merchant-name text-base font-semibold mt-1 flex gap-2 items-center justify-center">
//                     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M15.3 7.50065L15.8 10.0007H4.2L4.7 7.50065H15.3ZM16.6667 3.33398H3.33333V5.00065H16.6667V3.33398ZM16.6667 5.83398H3.33333L2.5 10.0007V11.6673H3.33333V16.6673H11.6667V11.6673H15V16.6673H16.6667V11.6673H17.5V10.0007L16.6667 5.83398ZM5 15.0007V11.6673H10V15.0007H5Z" fill="#7042D2" />
//                     </svg>
//                     {merchantName}
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Main Content Area with Slide Animations */}
//             <div className="relative">
//               {/* Step: Select Currency */}
//               <ScreenTransition currentStep={step} targetStep="select-currency">
//                 <div className="pb-6 pt-6 px-6 bg-white rounded-t-2xl blockchain-network">
//                   <PaymentMethods
//                     onSelect={onPaymentMethodSelect}
//                     selected={selectedPaymentMethod}
//                     theme={theme}
//                     supportedNetworks={supportedNetworks}
//                   />
//                 </div>
//               </ScreenTransition>

//               {/* Step: Confirm Payment */}
//               <ScreenTransition currentStep={step} targetStep="confirm">
//                 {selectedPaymentMethod && payment && (
//                   <div>
//                     <div className="p-4 rounded-2xl mb-4 bg-white">
//                       <h3 className="text-lg font-medium mb-2 text-gray-800">
//                         Payment Details
//                       </h3>
//                       <div className="space-y-2 bg-[#EDE4FF] p-3 rounded-xl">
//                         <div className="flex justify-between">
//                           <span className="font-medium">Currency:</span>
//                           <span className="font-medium">{selectedPaymentMethod.currency}</span>
//                         </div>

//                         <div className='border border-b border-gray-400'></div>

//                         <div className="flex justify-between">
//                           <span className="font-medium">Network:</span>
//                           <span className="font-medium">{getNetworkDisplayName(selectedPaymentMethod.network)}</span>
//                         </div>

//                         <div className='border border-b border-gray-400'></div>

//                         {/* Fee info with dynamic percentage */}
//                         {payment.feeChargedTo === 'customer' && payment.feeAmount > 0 ? (
//                           <>
//                             <div className="flex justify-between">
//                               <span className="font-medium">Processing Fee:</span>
//                               <span className="font-medium">{formatFeePercentage()}%</span>
//                             </div>

//                             <div className='border border-b border-gray-400'></div>


//                             <div className="flex justify-between border-t pt-2 mt-1">
//                               <span className="font-bold">Total:</span>
//                               <span className="font-bold text-lg">${formatAmount(payment.totalAmount)}</span>
//                             </div>
//                           </>
//                         ) : (
//                           <>
//                             <div className="flex justify-between">
//                               <span className="font-medium">Processing Fee:</span>
//                               <span className="font-medium">Included by merchant</span>
//                             </div>

//                             <div className='border border-b border-gray-400'></div>

//                                 <div className="">
//                               <div className="flex justify-between">
//                                 <span className="font-bold">Total:</span>
//                                 <span className="font-bold text-lg">${formatAmount(payment.totalAmount)}</span>
//                               </div>
//                               <div className="text-xs text-gray-500 mt-1">
//                                 Processing fee is covered by the merchant
//                               </div>
//                             </div>
//                           </>
//                         )}
//                       </div>
//                     </div>

//                     {/* Payment Method Tabs */}
//                     <div className="mb-4 px-4">
//                       <div className="flex border-b border-gray-200">
//                         <button
//                           onClick={() => setPaymentType('wallet')}
//                           className={`py-2 px-4 text-sm font-medium ${paymentType === 'wallet'
//                             ? 'border-b-2 border-purple-600 text-purple-600'
//                             : 'text-gray-500 hover:text-gray-700'
//                             }`}
//                         >
//                           Connect Wallet
//                         </button>
//                         <button
//                           onClick={() => setPaymentType('qrcode')}
//                           className={`py-2 px-4 text-sm font-medium ${paymentType === 'qrcode'
//                             ? 'border-b-2 border-purple-600 text-purple-600'
//                             : 'text-gray-500 hover:text-gray-700'
//                             }`}
//                         >
//                           QR Code
//                         </button>
//                       </div>
//                     </div>

//                     {/* Payment options */}
//                     {testMode ? (
//                       <div className="p-4 rounded-lg mb-4 bg-blue-50">
//                         <div className="flex items-center">
//                           <div className="bg-purple-600 rounded-full p-2 mr-3">
//                             <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                             </svg>
//                           </div>
//                           <div>
//                             <h3 className="font-medium text-gray-800">Test Mode Payment</h3>
//                             <p className="text-sm text-gray-600">Click "Pay Now" to simulate a successful payment</p>
//                           </div>
//                         </div>
//                       </div>
//                     ) : paymentType === 'qrcode' ? (
//                       <div className="mb-4">
//                         <QRCode
//                           walletAddress={getWalletAddressForNetwork()}
//                           amount={payment.totalAmount || payment.amount}
//                           currency={selectedPaymentMethod.currency}
//                           network={selectedPaymentMethod.network}
//                           theme={theme}
//                         />
//                       </div>
//                     ) : (
//                       <div className="space-y-3 mb-4">
//                         {supportedWallets.length === 0 ? (
//                           <div className="p-4 rounded-lg bg-yellow-50">
//                             <div className="flex items-center">
//                               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//                               </svg>
//                               <div>
//                                 <h3 className="font-medium text-gray-800">No Compatible Wallets</h3>
//                                 <p className="text-sm text-gray-600">
//                                   No wallets detected for {getNetworkDisplayName(selectedPaymentMethod.network)} network
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                         ) : (
//                           <WalletDropdown
//                             supportedWallets={supportedWallets}
//                             availableWallets={availableWallets}
//                             walletConnection={walletConnection}
//                             onConnectWallet={onConnectWallet}
//                             getWalletDisplayName={getWalletDisplayName}
//                             getWalletIcon={getWalletIcon}
//                             theme={theme}
//                           />
//                         )}
//                       </div>
//                     )}

//                     {/* Display any errors */}
//                     {error && (
//                       <div className="p-3 rounded-lg bg-red-50 mb-4 text-red-600 text-sm">
//                         {error}
//                       </div>
//                     )}

//                     {/* Navigation buttons */}
//                     <div className="grid grid-cols-2 gap-3 mb-3 px-4">
//                       <button
//                         type="button"
//                         onClick={onBack}
//                         className="w-full py-2 px-4 bg-gray-200 hover:bg-gray-300 text-purple-600 font-medium rounded-md"
//                       >
//                         Back
//                       </button>
//                       <button
//                         type="button"
//                         onClick={() => onPayment(paymentType === 'qrcode')}
//                         className="bg-green-600 text-white w-full py-2 px-4 font-medium rounded-md"
//                         disabled={!testMode && paymentType === 'wallet' && !walletConnection}
//                       >
//                         {paymentType === 'qrcode' ? 'I have sent the payment' : 'Pay Now'}
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </ScreenTransition>

//               {/* Step: Processing */}
//               <ScreenTransition currentStep={step} targetStep="processing">
//                 <PaymentStatus
//                   status="processing"
//                   theme={theme}
//                   message="Processing your payment..."
//                   processingStartTime={processingStartTime}
//                   paymentNetwork={paymentNetwork || selectedPaymentMethod?.network}
//                   transactionHash={transactionHash}
//                 />
//               </ScreenTransition>

//               {/* Step: Success */}
//               <ScreenTransition currentStep={step} targetStep="success">
//                 <PaymentStatus
//                   status="success"
//                   theme={theme}
//                   message="Payment successful!"
//                   payment={payment}
//                   transactionHash={transactionHash}
//                   selectedPaymentMethod={selectedPaymentMethod}
//                   merchantName={merchantName}
//                   onClose={handleSuccessClose}
//                   pendingBackendConfirmation={pendingBackendConfirmation}
//                 />
//               </ScreenTransition>

//               {/* Step: Error */}
//               <ScreenTransition currentStep={step} targetStep="error">
//                 <div>
//                   <PaymentStatus
//                     status="error"
//                     theme={theme}
//                     message={error || "An error occurred while processing your payment."}
//                   />
//                   <button
//                     type="button"
//                     onClick={onBack}
//                     className="mt-4 w-full py-2 px-4 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-md"
//                   >
//                     Try Again
//                   </button>
//                 </div>
//               </ScreenTransition>
//             </div>

//             {/* Footer */}
//             {step !== 'success' && (
//               <div className="text-center text-xs text-gray-500 flex items-center justify-center gap-1 py-6 bg-white rounded-b-3xl">
//                 <p>Powered by <span className='text-purple-600'>Coinley</span> - Secure Cryptocurrency Payments</p>
//                 <svg className="inline w-4 h-4 text-green-500 ml-1" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                   <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
//                   <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                 </svg>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CoinleyModal;


















// // CoinleyModal.jsx 
// import React, { useState, useEffect, useRef } from 'react';
// import PaymentMethods from './PaymentMethods';
// import PaymentStatus from './PaymentStatus';
// import QRCode from './QRCode';
// import { WALLET_TYPES, getWalletInstallUrl, getAvailableWallets, detectWallets, debugWalletEnvironment } from '../services/walletService';
// import logo from '../assets/Logomark.png';

// // Wallet Dropdown Component - Enhanced with Trust Wallet
// const WalletDropdown = ({
//   supportedWallets,
//   availableWallets,
//   walletConnection,
//   onConnectWallet,
//   getWalletDisplayName,
//   getWalletIcon,
//   theme
// }) => {
//   const [walletDropdownOpen, setWalletDropdownOpen] = useState(false);
//   const walletDropdownRef = useRef(null);

//   // Close dropdown on outside click
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (walletDropdownRef.current && !walletDropdownRef.current.contains(event.target)) {
//         setWalletDropdownOpen(false);
//       }
//     }
//     if (walletDropdownOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     } else {
//       document.removeEventListener('mousedown', handleClickOutside);
//     }
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [walletDropdownOpen]);

//   // Sort wallets: connected first, then detected, then others
//   const sortedWallets = [...supportedWallets].sort((a, b) => {
//     const aConnected = walletConnection?.walletType === a;
//     const bConnected = walletConnection?.walletType === b;
//     const aDetected = availableWallets[a];
//     const bDetected = availableWallets[b];

//     if (aConnected && !bConnected) return -1;
//     if (bConnected && !aConnected) return 1;
//     if (aDetected && !bDetected) return -1;
//     if (bDetected && !aDetected) return 1;
//     return 0;
//   });

//   const getWalletStatus = (walletType) => {
//     const isConnected = walletConnection?.walletType === walletType;
//     const isDetected = availableWallets[walletType];

//     if (isConnected) return { text: 'Connected', color: 'green' };
//     if (isDetected) return { text: 'Detected', color: 'blue' };
//     return { text: 'Not Installed', color: 'gray' };
//   };

//   const getSelectedWalletDisplay = () => {
//     if (walletConnection) {
//       const status = getWalletStatus(walletConnection.walletType);
//       return (
//         <div className="flex items-center gap-3">
//           <img
//             src={getWalletIcon(walletConnection.walletType)}
//             alt={getWalletDisplayName(walletConnection.walletType)}
//             className="h-8 w-8"
//             onError={(e) => { e.target.style.display = 'none'; }}
//           />
//           <div className="flex flex-col">
//             <span className="text-base font-normal">{getWalletDisplayName(walletConnection.walletType)}</span>
//             <span className={`text-xs ${status.color === 'green' ? 'text-green-600' :
//               status.color === 'blue' ? 'text-blue-600' : 'text-gray-500'
//               }`}>
//               {status.text}
//             </span>
//           </div>
//         </div>
//       );
//     }

//     // Show first detected wallet as default suggestion
//     const firstDetected = sortedWallets.find(wallet => availableWallets[wallet]);
//     if (firstDetected) {
//       return (
//         <div className="flex items-center gap-3">
//           <img
//             src={getWalletIcon(firstDetected)}
//             alt={getWalletDisplayName(firstDetected)}
//             className="h-8 w-8"
//             onError={(e) => { e.target.style.display = 'none'; }}
//           />
//           <span className="text-gray-500">Select {getWalletDisplayName(firstDetected)}...</span>
//         </div>
//       );
//     }

//     return <span className="text-gray-500">Choose a wallet...</span>;
//   };

//   return (
//     <div className="px-4">
//       <label className="block text-sm font-medium mb-2 text-gray-700">
//         Select Wallet
//       </label>

//       <div className="relative" ref={walletDropdownRef}>
//         <button
//           type="button"
//           className="w-full flex items-center justify-between py-4 bg-white rounded-2xl shadow border border-gray-200 text-gray-900 text-base font-normal focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50 transition"
//           onClick={() => setWalletDropdownOpen((open) => !open)}
//           style={{ minHeight: '56px', padding: '0.5rem' }}
//         >
//           {getSelectedWalletDisplay()}
//           <svg className={`w-5 h-5 ml-2 transition-transform ${walletDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//           </svg>
//         </button>

//         {walletDropdownOpen && (
//           <div className="absolute left-0 mt-2 px-2 w-full bg-white rounded-2xl shadow-lg border border-gray-100 z-20" style={{ minWidth: '100%' }}>
//             {sortedWallets.map((walletType) => {
//               const isConnected = walletConnection?.walletType === walletType;
//               const isDetected = availableWallets[walletType];
//               const status = getWalletStatus(walletType);

//               return (
//                 <div
//                   key={walletType}
//                   className={`flex items-center justify-between mt-1 mb-1 px-2 py-3 rounded-2xl transition ${isConnected ? 'bg-green-50' :
//                     isDetected ? 'hover:bg-gray-100 cursor-pointer' :
//                       'opacity-60 cursor-not-allowed'
//                     }`}
//                   style={{ minHeight: '56px' }}
//                   onClick={() => {
//                     if (isDetected && !isConnected) {
//                       setWalletDropdownOpen(false);
//                       onConnectWallet(walletType);
//                     }
//                   }}
//                 >
//                   <div className="flex items-center gap-3">
//                     <img
//                       src={getWalletIcon(walletType)}
//                       alt={getWalletDisplayName(walletType)}
//                       className="h-8 w-8"
//                       onError={(e) => { e.target.style.display = 'none'; }}
//                     />
//                     <div className="flex flex-col">
//                       <span className={`text-base font-normal ${isConnected ? 'text-green-800' : 'text-gray-900'
//                         }`}>
//                         {getWalletDisplayName(walletType)}
//                       </span>
//                       <span className={`text-xs ${status.color === 'green' ? 'text-green-600' :
//                         status.color === 'blue' ? 'text-blue-600' : 'text-gray-500'
//                         }`}>
//                         {status.text}
//                       </span>
//                     </div>
//                   </div>

//                   <div className="flex items-center">
//                     {isConnected ? (
//                       <div className="flex items-center space-x-2">
//                         <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
//                         <span className="text-xs text-green-600 font-medium">Ready</span>
//                       </div>
//                     ) : isDetected ? (
//                       <span className="text-xs text-blue-600 font-medium">Click to connect</span>
//                     ) : (
//                       <a
//                         href={getWalletInstallUrl(walletType)}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="text-xs text-gray-500 hover:text-gray-700 underline"
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         Install
//                       </a>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // Screen transition wrapper component
// const ScreenTransition = ({
//   currentStep,
//   targetStep,
//   children,
//   className = "",
//   duration = 300
// }) => {
//   const [isVisible, setIsVisible] = useState(currentStep === targetStep);
//   const [shouldRender, setShouldRender] = useState(currentStep === targetStep);

//   useEffect(() => {
//     if (currentStep === targetStep) {
//       setShouldRender(true);
//       setTimeout(() => setIsVisible(true), 10);
//     } else {
//       setIsVisible(false);
//       setTimeout(() => setShouldRender(false), duration);
//     }
//   }, [currentStep, targetStep, duration]);

//   if (!shouldRender) return null;

//   return (
//     <div
//       className={`
//         transition-all duration-300 ease-out
//         ${isVisible
//           ? 'transform translate-y-0 opacity-100'
//           : 'transform translate-y-full opacity-0'
//         }
//         ${className}
//       `}
//       style={{
//         transitionDuration: `${duration}ms`
//       }}
//     >
//       {children}
//     </div>
//   );
// };

// const CoinleyModal = ({
//   isOpen,
//   onClose,
//   payment,
//   paymentStatus,
//   selectedPaymentMethod,
//   onPaymentMethodSelect,
//   onPayment,
//   onBack,
//   error,
//   theme = 'light',
//   merchantName,
//   transactionHash,
//   walletConnection,
//   onConnectWallet,
//   testMode = false,
//   supportedNetworks = [],
//   availableWallets = {},
//   supportedWallets = [],
//   step = 'select-currency',
//   merchantWalletAddresses = {},
//   debug = false,
//   processingStartTime = null,
//   pendingBackendConfirmation = false,
//   paymentNetwork = null,
//   merchantFeePercentage = 0.0175
// }) => {
//   const [paymentType, setPaymentType] = useState('wallet');

//   // Debug payment data
//   useEffect(() => {
//     if (payment && debug) {
//       console.log('CoinleyModal - Payment data:', {
//         amount: payment.amount,
//         feeAmount: payment.feeAmount,
//         totalAmount: payment.totalAmount,
//         feeChargedTo: payment.feeChargedTo,
//         originalAmount: payment.originalAmount,
//         merchantFeePercentage: merchantFeePercentage,
//         dynamicFeeDisplay: `${(merchantFeePercentage * 100).toFixed(2)}%`
//       });
//     }
//   }, [payment, debug, merchantFeePercentage]);

//   // Get wallet address for current network
//   const getWalletAddressForNetwork = () => {
//     if (!selectedPaymentMethod) return 'No network selected';

//     const networkAddress = merchantWalletAddresses[selectedPaymentMethod.network];
//     if (networkAddress) {
//       return networkAddress;
//     }

//     if (payment?.recipientWallet) {
//       return payment.recipientWallet;
//     }

//     return 'No wallet address configured for this network';
//   };

//   // Handle close for success screen
//   const handleSuccessClose = () => {
//     console.log("Success screen close button clicked");
//     if (onClose) {
//       onClose();
//     }
//   };

//   // Utility functions
//   const formatAmount = (amount) => {
//     return parseFloat(amount).toFixed(2);
//   };

//   const formatTransactionHash = (hash) => {
//     if (!hash) return '';
//     if (hash.length <= 14) return hash;
//     return `${hash.slice(0, 8)}...${hash.slice(-6)}`;
//   };

//   const getNetworkDisplayName = (network) => {
//     const names = {
//       ethereum: 'Ethereum',
//       bsc: 'BSC',
//       tron: 'Tron',
//       algorand: 'Algorand',
//       solana: 'Solana'
//     };
//     return names[network] || network;
//   };

//   // Enhanced wallet display names with Trust Wallet
//   const getWalletDisplayName = (walletType) => {
//     const names = {
//       [WALLET_TYPES.METAMASK]: 'MetaMask',
//       [WALLET_TYPES.TRONLINK]: 'TronLink',
//       [WALLET_TYPES.TRUST_WALLET]: 'Trust Wallet',
//       [WALLET_TYPES.LUTE]: 'Lute Wallet',
//       [WALLET_TYPES.PHANTOM]: 'Phantom'
//     };
//     return names[walletType] || walletType;
//   };

//   // Enhanced wallet icons with Trust Wallet
//   const getWalletIcon = (walletType) => {
//     const icons = {
//       [WALLET_TYPES.METAMASK]: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3ymr3UNKopfI0NmUY95Dr-0589vG-91KuAA&s',
//       [WALLET_TYPES.TRONLINK]: 'https://www.tronlink.org/images/logo.png',
//       [WALLET_TYPES.TRUST_WALLET]: 'https://trustwallet.com/assets/images/media/trust_platform.svg',
//       [WALLET_TYPES.LUTE]: 'https://lute.app/logo.png',
//       [WALLET_TYPES.PHANTOM]: 'https://phantom.app/img/phantom-logo.png'
//     };
//     return icons[walletType] || '';
//   };

//   // Helper to format the dynamic fee percentage
//   const formatFeePercentage = () => {
//     return (merchantFeePercentage * 100).toFixed(2);
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50">
//       <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} aria-hidden="true" />
//       <div className="fixed inset-0 overflow-y-auto">
//         <div className="flex min-h-screen items-center justify-center p-4">
//           <div className="coinley-modal relative pt-6 w-full max-w-md mx-auto shadow-xl bg-gray-100 rounded-3xl overflow-hidden">
//             {/* Header with Logo */}
//             <div className="bg-white flex justify-between items-center mb-6 mr-3 ml-3 py-4 px-2 rounded-full">
//               <div className="flex-1 flex items-center gap-2 px-4">
//                 <img src={logo} className="w-auto h-auto" alt="Coinley Logo" />
//                 <span className="text-lg font-semibold text-gray-800">Payment Details</span>
//               </div>
//               {step !== 'success' && step !== 'processing' && (
//                 <button
//                   onClick={onClose}
//                   className="text-gray-500 hover:text-gray-700 focus:outline-none"
//                 >
//                   <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               )}
//             </div>

//             {/* Payment Summary */}
//             {payment && step !== 'success' && (
//               <div className="mb-6">
//                 <div className="text-center">
//                   <div className="text-sm text-gray-600">
//                     Total Amount
//                   </div>
//                   <div className="coinley-amount-display text-3xl md:text-9xl lg:text-9xl font-bold text-[#7042D2] mt-2 leading-tight tracking-tight">
//                     ${formatAmount(payment.totalAmount || payment.amount)}
//                   </div>

//                   {/* Show fee breakdown with dynamic percentage */}
//                   {payment.feeChargedTo === 'customer' && payment.feeAmount > 0 && (
//                     <div className="mt-2 text-sm text-gray-500">
//                       {/* Fee details removed for cleaner UI */}
//                     </div>
//                   )}

//                   {/* Show different message when merchant pays fees */}
//                   {payment.feeChargedTo === 'merchant' && (
//                     <div className="mt-2 text-sm text-gray-500">
//                       No additional fees
//                     </div>
//                   )}

//                   <div className="text-sm text-gray-600 mt-4">Payment to:</div>
//                   <div className="coinley-merchant-name text-base font-semibold mt-1 flex gap-2 items-center justify-center">
//                     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M15.3 7.50065L15.8 10.0007H4.2L4.7 7.50065H15.3ZM16.6667 3.33398H3.33333V5.00065H16.6667V3.33398ZM16.6667 5.83398H3.33333L2.5 10.0007V11.6673H3.33333V16.6673H11.6667V11.6673H15V16.6673H16.6667V11.6673H17.5V10.0007L16.6667 5.83398ZM5 15.0007V11.6673H10V15.0007H5Z" fill="#7042D2" />
//                     </svg>
//                     {merchantName}
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Main Content Area with Slide Animations */}
//             <div className="relative">
//               {/* Step: Select Currency */}
//               <ScreenTransition currentStep={step} targetStep="select-currency">
//                 <div className="pb-6 pt-6 px-6 bg-white rounded-t-2xl blockchain-network">
//                   <PaymentMethods
//                     onSelect={onPaymentMethodSelect}
//                     selected={selectedPaymentMethod}
//                     theme={theme}
//                     supportedNetworks={supportedNetworks}
//                   />
//                 </div>
//               </ScreenTransition>

//               {/* Step: Confirm Payment */}
//               <ScreenTransition currentStep={step} targetStep="confirm">
//                 {selectedPaymentMethod && payment && (
//                   <div>

//                     {/* Payment Details - Hide when QR code is selected */}
//                     {paymentType === 'wallet' && (
//                       <div className="p-4 rounded-2xl mb-4 bg-white">
//                         <h3 className="text-lg font-medium mb-2 text-gray-800">
//                           Payment Details
//                         </h3>
//                         <div className="space-y-2 bg-[#EDE4FF] p-3 rounded-xl">
//                           <div className="flex justify-between">
//                             <span className="font-medium">Currency:</span>
//                             <span className="font-medium">{selectedPaymentMethod.currency}</span>
//                           </div>

//                           <div className='border border-b border-gray-400'></div>

//                           <div className="flex justify-between">
//                             <span className="font-medium">Network:</span>
//                             <span className="font-medium">{getNetworkDisplayName(selectedPaymentMethod.network)}</span>
//                           </div>

//                           <div className='border border-b border-gray-400'></div>

//                           {/* Fee info with dynamic percentage */}
//                           {payment.feeChargedTo === 'customer' && payment.feeAmount > 0 ? (
//                             <>
//                               <div className="flex justify-between">
//                                 <span className="font-medium">Processing Fee:</span>
//                                 <span className="font-medium">{formatFeePercentage()}%</span>
//                               </div>

//                               <div className='border border-b border-gray-400'></div>


//                               <div className="flex justify-between border-t pt-2 mt-1">
//                                 <span className="font-bold">Total:</span>
//                                 <span className="font-bold text-lg">${formatAmount(payment.totalAmount)}</span>
//                               </div>
//                             </>
//                           ) : (
//                             <>
//                               <div className="flex justify-between">
//                                 <span className="font-medium">Processing Fee:</span>
//                                 <span className="font-medium">Included by merchant</span>
//                               </div>

//                               <div className='border border-b border-gray-400'></div>

//                               <div className="">
//                                 <div className="flex justify-between">
//                                   <span className="font-bold">Total:</span>
//                                   <span className="font-bold text-lg">${formatAmount(payment.totalAmount)}</span>
//                                 </div>
//                                 <div className="text-xs text-gray-500 mt-1">
//                                   Processing fee is covered by the merchant
//                                 </div>
//                               </div>
//                             </>
//                           )}
//                         </div>
//                       </div>
//                     )}

//                     {/* Payment Method Tabs */}
//                     <div className="mb-4 px-4">
//                       <div className="flex border-b border-gray-200">
//                         <button
//                           onClick={() => setPaymentType('wallet')}
//                           className={`py-2 px-4 text-sm font-medium ${paymentType === 'wallet'
//                             ? 'border-b-2 border-purple-600 text-purple-600'
//                             : 'text-gray-500 hover:text-gray-700'
//                             }`}
//                         >
//                           Connect Wallet
//                         </button>
//                         <button
//                           onClick={() => setPaymentType('qrcode')}
//                           className={`py-2 px-4 text-sm font-medium ${paymentType === 'qrcode'
//                             ? 'border-b-2 border-purple-600 text-purple-600'
//                             : 'text-gray-500 hover:text-gray-700'
//                             }`}
//                         >
//                           QR Code
//                         </button>
//                       </div>
//                     </div>

//                     {/* Payment options */}
//                     {testMode ? (
//                       <div className="p-4 rounded-lg mb-4 bg-blue-50">
//                         <div className="flex items-center">
//                           <div className="bg-purple-600 rounded-full p-2 mr-3">
//                             <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                             </svg>
//                           </div>
//                           <div>
//                             <h3 className="font-medium text-gray-800">Test Mode Payment</h3>
//                             <p className="text-sm text-gray-600">Click "Pay Now" to simulate a successful payment</p>
//                           </div>
//                         </div>
//                       </div>
//                     ) : paymentType === 'qrcode' ? (
//                       <div className="mb-4">
//                         <QRCode
//                           walletAddress={getWalletAddressForNetwork()}
//                           amount={payment.totalAmount || payment.amount}
//                           currency={selectedPaymentMethod.currency}
//                           network={selectedPaymentMethod.network}
//                           theme={theme}
//                         />
//                       </div>
//                     ) : (
//                       <div className="space-y-3 mb-4">
//                         {supportedWallets.length === 0 ? (
//                           <div className="p-4 rounded-lg bg-yellow-50">
//                             <div className="flex items-center">
//                               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//                               </svg>
//                               <div>
//                                 <h3 className="font-medium text-gray-800">No Compatible Wallets</h3>
//                                 <p className="text-sm text-gray-600">
//                                   No wallets detected for {getNetworkDisplayName(selectedPaymentMethod.network)} network
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                         ) : (
//                           <WalletDropdown
//                             supportedWallets={supportedWallets}
//                             availableWallets={availableWallets}
//                             walletConnection={walletConnection}
//                             onConnectWallet={onConnectWallet}
//                             getWalletDisplayName={getWalletDisplayName}
//                             getWalletIcon={getWalletIcon}
//                             theme={theme}
//                           />
//                         )}
//                       </div>
//                     )}

//                     {/* Display any errors */}
//                     {error && (
//                       <div className="p-3 rounded-lg bg-red-50 mb-4 text-red-600 text-sm">
//                         {error}
//                       </div>
//                     )}

//                     {/* Navigation buttons */}
//                     <div className="grid grid-cols-2 gap-3 mb-3 px-4">
//                       <button
//                         type="button"
//                         onClick={onBack}
//                         className="w-full py-2 px-4 bg-gray-200 hover:bg-gray-300 text-purple-600 font-medium rounded-md"
//                       >
//                         Back
//                       </button>
//                       <button
//                         type="button"
//                         onClick={() => onPayment(paymentType === 'qrcode')}
//                         className="bg-green-600 text-white w-full py-2 px-4 font-medium rounded-md"
//                         disabled={!testMode && paymentType === 'wallet' && !walletConnection}
//                       >
//                         {paymentType === 'qrcode' ? 'I have sent the payment' : 'Pay Now'}
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </ScreenTransition>

//               {/* Step: Processing */}
//               <ScreenTransition currentStep={step} targetStep="processing">
//                 <PaymentStatus
//                   status="processing"
//                   theme={theme}
//                   message="Processing your payment..."
//                   processingStartTime={processingStartTime}
//                   paymentNetwork={paymentNetwork || selectedPaymentMethod?.network}
//                   transactionHash={transactionHash}
//                 />
//               </ScreenTransition>

//               {/* Step: Success */}
//               <ScreenTransition currentStep={step} targetStep="success">
//                 <PaymentStatus
//                   status="success"
//                   theme={theme}
//                   message="Payment successful!"
//                   payment={payment}
//                   transactionHash={transactionHash}
//                   selectedPaymentMethod={selectedPaymentMethod}
//                   merchantName={merchantName}
//                   onClose={handleSuccessClose}
//                   pendingBackendConfirmation={pendingBackendConfirmation}
//                 />
//               </ScreenTransition>

//               {/* Step: Error */}
//               <ScreenTransition currentStep={step} targetStep="error">
//                 <div>
//                   <PaymentStatus
//                     status="error"
//                     theme={theme}
//                     message={error || "An error occurred while processing your payment."}
//                   />
//                   <button
//                     type="button"
//                     onClick={onBack}
//                     className="mt-4 w-full py-2 px-4 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-md"
//                   >
//                     Try Again
//                   </button>
//                 </div>
//               </ScreenTransition>
//             </div>

//             {/* Footer */}
//             {step !== 'success' && (
//               <div className="text-center text-xs text-gray-500 flex items-center justify-center gap-1 py-6 bg-white rounded-b-3xl">
//                 <p>Powered by <span className='text-purple-600'>Coinley</span> - Secure Cryptocurrency Payments</p>
//                 <svg className="inline w-4 h-4 text-green-500 ml-1" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                   <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
//                   <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                 </svg>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CoinleyModal;







// // Updated WalletDropdown Component for CoinleyModal.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import { getAvailableWallets } from '../services/walletService';

// const WalletDropdown = ({
//   selectedNetwork,
//   walletConnection,
//   onConnectWallet,
//   theme
// }) => {
//   const [walletDropdownOpen, setWalletDropdownOpen] = useState(false);
//   const [availableWallets, setAvailableWallets] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const walletDropdownRef = useRef(null);

//   // Load wallets from Coinley Connect when network changes
//   useEffect(() => {
//     const loadWallets = async () => {
//       if (!selectedNetwork) return;
      
//       try {
//         setLoading(true);
//         console.log('🔍 Loading wallets for network:', selectedNetwork);
        
//         // Get wallets from Coinley Connect service
//         const wallets = await getAvailableWallets(selectedNetwork);
//         console.log('✅ Loaded wallets from Coinley Connect:', wallets);
        
//         setAvailableWallets(wallets);
//       } catch (error) {
//         console.error('❌ Failed to load wallets:', error);
//         // Fallback wallets
//         setAvailableWallets([
//           {
//             type: 'metamask',
//             name: 'MetaMask',
//             icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3ymr3UNKopfI0NmUY95Dr-0589vG-91KuAA&s',
//             description: 'Connect using browser extension',
//             isInstalled: typeof window.ethereum !== 'undefined',
//             status: typeof window.ethereum !== 'undefined' ? 'installed' : 'not_installed',
//             downloadUrl: 'https://metamask.io/download/'
//           }
//         ]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadWallets();
//   }, [selectedNetwork]);

//   // Close dropdown on outside click
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (walletDropdownRef.current && !walletDropdownRef.current.contains(event.target)) {
//         setWalletDropdownOpen(false);
//       }
//     }
//     if (walletDropdownOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     } else {
//       document.removeEventListener('mousedown', handleClickOutside);
//     }
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [walletDropdownOpen]);

//   const getWalletStatus = (wallet) => {
//     const isConnected = walletConnection?.walletType === wallet.type;
    
//     if (isConnected) return { text: 'Connected', color: 'green' };
//     if (wallet.isInstalled) return { text: 'Detected', color: 'blue' };
//     return { text: 'Not Installed', color: 'gray' };
//   };

//   const getSelectedWalletDisplay = () => {
//     if (walletConnection) {
//       const connectedWallet = availableWallets.find(w => w.type === walletConnection.walletType);
//       const status = getWalletStatus(connectedWallet || { type: walletConnection.walletType, isInstalled: true });
      
//       return (
//         <div className="flex items-center gap-3">
//           <img
//             src={connectedWallet?.icon || 'https://via.placeholder.com/32'}
//             alt={connectedWallet?.name || 'Wallet'}
//             className="h-8 w-8 rounded"
//             onError={(e) => { e.target.style.display = 'none'; }}
//           />
//           <div className="flex flex-col">
//             <span className="text-base font-normal">{connectedWallet?.name || 'Connected Wallet'}</span>
//             <span className={`text-xs ${status.color === 'green' ? 'text-green-600' :
//               status.color === 'blue' ? 'text-blue-600' : 'text-gray-500'
//               }`}>
//               {status.text}
//             </span>
//           </div>
//         </div>
//       );
//     }

//     // Show loading or default state
//     if (loading) {
//       return (
//         <div className="flex items-center gap-3">
//           <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
//           <span className="text-gray-500">Loading wallets...</span>
//         </div>
//       );
//     }

//     // Show first installed wallet as suggestion
//     const firstInstalled = availableWallets.find(wallet => wallet.isInstalled);
//     if (firstInstalled) {
//       return (
//         <div className="flex items-center gap-3">
//           <img
//             src={firstInstalled.icon}
//             alt={firstInstalled.name}
//             className="h-8 w-8 rounded"
//             onError={(e) => { e.target.style.display = 'none'; }}
//           />
//           <span className="text-gray-500">Select {firstInstalled.name}...</span>
//         </div>
//       );
//     }

//     return <span className="text-gray-500">Choose a wallet...</span>;
//   };

//   if (!selectedNetwork) {
//     return (
//       <div className="px-4">
//         <label className="block text-sm font-medium mb-2 text-gray-700">
//           Select Wallet
//         </label>
//         <div className="w-full py-4 px-3 bg-gray-100 rounded-2xl text-gray-500 text-center">
//           Please select a network first
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="px-4">
//       <label className="block text-sm font-medium mb-2 text-gray-700">
//         Select Wallet
//       </label>

//       <div className="relative" ref={walletDropdownRef}>
//         <button
//           type="button"
//           className="w-full flex items-center justify-between py-4 bg-white rounded-2xl shadow border border-gray-200 text-gray-900 text-base font-normal focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50 transition"
//           onClick={() => setWalletDropdownOpen((open) => !open)}
//           style={{ minHeight: '56px', padding: '0.5rem' }}
//         >
//           {getSelectedWalletDisplay()}
//           <svg className={`w-5 h-5 ml-2 transition-transform ${walletDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//           </svg>
//         </button>

//         {walletDropdownOpen && (
//           <div className="absolute left-0 mt-2 px-2 w-full bg-white rounded-2xl shadow-lg border border-gray-100 z-20" style={{ minWidth: '100%' }}>
//             {loading ? (
//               <div className="text-center py-4 text-gray-500 text-sm">
//                 Loading wallets...
//               </div>
//             ) : availableWallets.length === 0 ? (
//               <div className="text-center py-4 text-gray-500 text-sm">
//                 No wallets available for this network
//               </div>
//             ) : (
//               availableWallets.map((wallet) => {
//                 const isConnected = walletConnection?.walletType === wallet.type;
//                 const status = getWalletStatus(wallet);

//                 return (
//                   <div
//                     key={wallet.type}
//                     className={`flex items-center justify-between mt-1 mb-1 px-2 py-3 rounded-2xl transition ${isConnected ? 'bg-green-50' :
//                       wallet.isInstalled ? 'hover:bg-gray-100 cursor-pointer' :
//                         'opacity-60 cursor-not-allowed'
//                       }`}
//                     style={{ minHeight: '56px' }}
//                     onClick={() => {
//                       if (wallet.isInstalled && !isConnected) {
//                         setWalletDropdownOpen(false);
//                         console.log('🔗 Connecting to wallet directly:', wallet.type);
//                         onConnectWallet(wallet.type);
//                       }
//                     }}
//                   >
//                     <div className="flex items-center gap-3">
//                       <img
//                         src={wallet.icon}
//                         alt={wallet.name}
//                         className="h-8 w-8 rounded"
//                         onError={(e) => { 
//                           e.target.src = 'https://via.placeholder.com/32'; 
//                         }}
//                       />
//                       <div className="flex flex-col">
//                         <span className={`text-base font-normal ${isConnected ? 'text-green-800' : 'text-gray-900'
//                           }`}>
//                           {wallet.name}
//                         </span>
//                         <span className="text-xs text-gray-500">
//                           {wallet.description}
//                         </span>
//                       </div>
//                     </div>

//                     <div className="flex items-center">
//                       {isConnected ? (
//                         <div className="flex items-center space-x-2">
//                           <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
//                           <span className="text-xs text-green-600 font-medium">Connected</span>
//                         </div>
//                       ) : wallet.isInstalled ? (
//                         <span className="text-xs text-blue-600 font-medium">Click to connect</span>
//                       ) : (
//                         <a
//                           href={wallet.downloadUrl}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="text-xs text-gray-500 hover:text-gray-700 underline"
//                           onClick={(e) => e.stopPropagation()}
//                         >
//                           Install
//                         </a>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })
//             )}
            
//             {/* Powered by Coinley Connect */}
//             <div className="text-center py-2 border-t border-gray-100 mt-2">
//               <span className="text-xs text-gray-400">
//                 Powered by Coinley Connect
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default WalletDropdown;















// CoinleyModal.jsx - Complete rewrite with embedded wallet interface
import React, { useState, useEffect, useRef } from 'react';
import PaymentMethods from './PaymentMethods';
import PaymentStatus from './PaymentStatus';
import QRCode from './QRCode';
import logo from '../assets/Logomark.png';

// Embedded Wallet Interface Component (Your Coinley Connect Design)
const EmbeddedWalletInterface = ({ onConnectWallet, selectedPaymentMethod }) => {
  const [selectedWalletType, setSelectedWalletType] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);

  const wallets = [
    {
      type: 'metamask',
      name: 'MetaMask',
      icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3ymr3UNKopfI0NmUY95Dr-0589vG-91KuAA&s',
      description: 'Connect using browser extension'
    },
    {
      type: 'phantom',
      name: 'Phantom',
      icon: 'https://coinlaunch.space/media/images/4/8/5/0/4850.sp3ow1.192x192.png',
      description: 'Connect using Phantom wallet'
    }
  ];

  const selectWallet = (walletType) => {
    setSelectedWalletType(walletType);
    setIsDropdownOpen(false);
  };

  const connectWallet = async () => {
    if (!selectedWalletType) return;
    
    setIsConnecting(true);
    
    try {
      if (selectedWalletType === 'metamask') {
        await connectMetaMask();
      } else if (selectedWalletType === 'phantom') {
        await connectPhantom();
      }
    } catch (error) {
      console.error('Connection failed:', error);
      alert('Failed to connect wallet. Please try again.');
    } finally {
      setIsConnecting(false);
    }
  };

  const connectMetaMask = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        const accounts = await window.ethereum.request({ 
          method: 'eth_requestAccounts' 
        });
        onConnectWallet('metamask');
      } catch (error) {
        throw error;
      }
    } else {
      alert('MetaMask is not installed. Please install MetaMask extension.');
      throw new Error('MetaMask not found');
    }
  };

  const connectPhantom = async () => {
    if (window.solana && window.solana.isPhantom) {
      try {
        const response = await window.solana.connect();
        onConnectWallet('phantom');
      } catch (error) {
        throw error;
      }
    } else {
      alert('Phantom wallet is not installed. Please install Phantom extension.');
      throw new Error('Phantom not found');
    }
  };

  const selectedWallet = wallets.find(w => w.type === selectedWalletType);

  return (
    <div className="space-y-4 mb-4 px-4">
      {/* Your Coinley Connect wallet interface */}
      <div style={{ position: 'relative', marginBottom: '20px' }}>
        <button
          style={{
            width: '100%',
            padding: '16px 20px',
            background: 'white',
            border: '2px solid #e5e7eb',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            color: '#374151',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            transition: 'all 0.2s ease',
            borderColor: isDropdownOpen ? '#3b82f6' : '#e5e7eb',
            boxShadow: isDropdownOpen ? '0 4px 12px rgba(59, 130, 246, 0.15)' : 'none'
          }}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          onMouseEnter={(e) => {
            if (!isDropdownOpen) {
              e.target.style.borderColor = '#3b82f6';
              e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.15)';
            }
          }}
          onMouseLeave={(e) => {
            if (!isDropdownOpen) {
              e.target.style.borderColor = '#e5e7eb';
              e.target.style.boxShadow = 'none';
            }
          }}
        >
          <span>{selectedWallet ? selectedWallet.name : 'Select a wallet'}</span>
          <span style={{
            transition: 'transform 0.2s ease',
            fontSize: '12px',
            color: '#6b7280',
            transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
          }}>
            ▼
          </span>
        </button>
        
        {isDropdownOpen && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            background: 'white',
            border: '2px solid #e5e7eb',
            borderTop: 'none',
            borderRadius: '0 0 12px 12px',
            boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
            zIndex: 10
          }}>
            {wallets.map((wallet, index) => (
              <div
                key={wallet.type}
                style={{
                  padding: '16px 20px',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease',
                  borderBottom: index < wallets.length - 1 ? '1px solid #f3f4f6' : 'none'
                }}
                onClick={() => selectWallet(wallet.type)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f8fafc';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  marginRight: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <img
                    src={wallet.icon}
                    alt={wallet.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                  />
                </div>
                <div>
                  <div style={{
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    {wallet.name}
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#6b7280',
                    marginTop: '2px'
                  }}>
                    {wallet.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <button
        style={{
          width: '100%',
          padding: '16px',
          background: selectedWalletType ? 'linear-gradient(135deg, #3b82f6, #8b5cf6)' : '#e5e7eb',
          color: selectedWalletType ? 'white' : '#9ca3af',
          border: 'none',
          borderRadius: '12px',
          fontSize: '16px',
          fontWeight: '600',
          cursor: selectedWalletType ? 'pointer' : 'not-allowed',
          transition: 'all 0.2s ease',
          opacity: selectedWalletType ? 1 : 0.5,
          pointerEvents: selectedWalletType ? 'auto' : 'none'
        }}
        onClick={connectWallet}
        disabled={!selectedWalletType || isConnecting}
        onMouseEnter={(e) => {
          if (selectedWalletType && !isConnecting) {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 25px rgba(59, 130, 246, 0.3)';
          }
        }}
        onMouseLeave={(e) => {
          if (selectedWalletType && !isConnecting) {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }
        }}
      >
        {isConnecting ? 'Connecting...' : 'Connect Wallet'}
      </button>
    </div>
  );
};

// Screen transition wrapper component
const ScreenTransition = ({
  currentStep,
  targetStep,
  children,
  className = "",
  duration = 300
}) => {
  const [isVisible, setIsVisible] = useState(currentStep === targetStep);
  const [shouldRender, setShouldRender] = useState(currentStep === targetStep);

  useEffect(() => {
    if (currentStep === targetStep) {
      setShouldRender(true);
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
      setTimeout(() => setShouldRender(false), duration);
    }
  }, [currentStep, targetStep, duration]);

  if (!shouldRender) return null;

  return (
    <div
      className={`
        transition-all duration-300 ease-out
        ${isVisible
          ? 'transform translate-y-0 opacity-100'
          : 'transform translate-y-full opacity-0'
        }
        ${className}
      `}
      style={{
        transitionDuration: `${duration}ms`
      }}
    >
      {children}
    </div>
  );
};

const CoinleyModal = ({
  isOpen,
  onClose,
  payment,
  paymentStatus,
  selectedPaymentMethod,
  onPaymentMethodSelect,
  onPayment,
  onBack,
  error,
  theme = 'light',
  merchantName,
  transactionHash,
  walletConnection,
  onConnectWallet,
  testMode = false,
  supportedNetworks = [],
  availableWallets = {},
  supportedWallets = [],
  step = 'select-currency',
  merchantWalletAddresses = {},
  debug = false,
  processingStartTime = null,
  pendingBackendConfirmation = false,
  paymentNetwork = null,
  merchantFeePercentage = 0.0175
}) => {
  const [paymentType, setPaymentType] = useState('wallet');

  // Debug payment data
  useEffect(() => {
    if (payment && debug) {
      console.log('CoinleyModal - Payment data:', {
        amount: payment.amount,
        feeAmount: payment.feeAmount,
        totalAmount: payment.totalAmount,
        feeChargedTo: payment.feeChargedTo,
        originalAmount: payment.originalAmount,
        merchantFeePercentage: merchantFeePercentage,
        dynamicFeeDisplay: `${(merchantFeePercentage * 100).toFixed(2)}%`
      });
    }
  }, [payment, debug, merchantFeePercentage]);

  // Get wallet address for current network
  const getWalletAddressForNetwork = () => {
    if (!selectedPaymentMethod) return 'No network selected';

    const networkAddress = merchantWalletAddresses[selectedPaymentMethod.network];
    if (networkAddress) {
      return networkAddress;
    }

    if (payment?.recipientWallet) {
      return payment.recipientWallet;
    }

    return 'No wallet address configured for this network';
  };

  // Handle close for success screen
  const handleSuccessClose = () => {
    if (onClose) {
      onClose();
    }
  };

  // Utility functions
  const formatAmount = (amount) => {
    return parseFloat(amount).toFixed(2);
  };

  const formatTransactionHash = (hash) => {
    if (!hash) return '';
    if (hash.length <= 14) return hash;
    return `${hash.slice(0, 8)}...${hash.slice(-6)}`;
  };

  const getNetworkDisplayName = (network) => {
    const names = {
      ethereum: 'Ethereum',
      bsc: 'BSC',
      tron: 'Tron',
      algorand: 'Algorand',
      solana: 'Solana'
    };
    return names[network] || network;
  };

  // Format recipient address
  const formatRecipientAddress = (address) => {
    if (!address) return 'N/A';
    if (address.length <= 16) return address;
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  // Helper to format the dynamic fee percentage
  const formatFeePercentage = () => {
    return (merchantFeePercentage * 100).toFixed(2);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} aria-hidden="true" />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-screen items-center justify-center p-4">
          <div className="coinley-modal relative pt-6 w-full max-w-md mx-auto shadow-xl bg-gray-100 rounded-3xl overflow-hidden">
            {/* Header with Logo */}
            <div className="bg-white flex justify-between items-center mb-6 mr-3 ml-3 py-4 px-2 rounded-full">
              <div className="flex-1 flex items-center gap-2 px-4">
                <img src={logo} className="w-auto h-auto" alt="Coinley Logo" />
                <span className="text-lg font-semibold text-gray-800">Payment Details</span>
              </div>
              {step !== 'success' && step !== 'processing' && (
                <button
                  onClick={onClose}
                  className="text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>

            {/* Payment Summary */}
            {payment && step !== 'success' && (
              <div className="mb-6">
                <div className="text-center">
                  <div className="text-sm text-gray-600">
                    Total Amount
                  </div>
                  <div className="coinley-amount-display text-3xl md:text-9xl lg:text-9xl font-bold text-[#7042D2] mt-2 leading-tight tracking-tight">
                    ${formatAmount(payment.totalAmount || payment.amount)}
                  </div>

                  {/* Show fee breakdown with dynamic percentage */}
                  {payment.feeChargedTo === 'customer' && payment.feeAmount > 0 && (
                    <div className="mt-2 text-sm text-gray-500">
                      {/* Fee details removed for cleaner UI */}
                    </div>
                  )}

                  {/* Show different message when merchant pays fees */}
                  {payment.feeChargedTo === 'merchant' && (
                    <div className="mt-2 text-sm text-gray-500">
                      No additional fees
                    </div>
                  )}

                  <div className="text-sm text-gray-600 mt-4">Payment to:</div>
                  <div className="coinley-merchant-name text-base font-semibold mt-1 flex gap-2 items-center justify-center">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.3 7.50065L15.8 10.0007H4.2L4.7 7.50065H15.3ZM16.6667 3.33398H3.33333V5.00065H16.6667V3.33398ZM16.6667 5.83398H3.33333L2.5 10.0007V11.6673H3.33333V16.6673H11.6667V11.6673H15V16.6673H16.6667V11.6673H17.5V10.0007L16.6667 5.83398ZM5 15.0007V11.6673H10V15.0007H5Z" fill="#7042D2" />
                    </svg>
                    {merchantName}
                  </div>
                </div>
              </div>
            )}

            {/* Main Content Area with Slide Animations */}
            <div className="relative">
              {/* Step: Select Currency */}
              <ScreenTransition currentStep={step} targetStep="select-currency">
                <div className="pb-6 pt-6 px-6 bg-white rounded-t-2xl blockchain-network">
                  <PaymentMethods
                    onSelect={onPaymentMethodSelect}
                    selected={selectedPaymentMethod}
                    theme={theme}
                    supportedNetworks={supportedNetworks}
                  />
                </div>
              </ScreenTransition>

              {/* Step: Confirm Payment */}
              <ScreenTransition currentStep={step} targetStep="confirm">
                {selectedPaymentMethod && payment && (
                  <div>
                    {/* Payment Details - Hide when QR code is selected */}
                    {paymentType === 'wallet' && (
                      <div className="p-4 rounded-2xl mb-4 bg-white">
                        <h3 className="text-lg font-medium mb-2 text-gray-800">
                          Payment Details
                        </h3>
                        <div className="space-y-2 bg-[#EDE4FF] p-3 rounded-xl">
                          <div className="flex justify-between">
                            <span className="font-medium">Currency:</span>
                            <span className="font-medium">{selectedPaymentMethod.currency}</span>
                          </div>

                          <div className='border border-b border-gray-400'></div>

                          <div className="flex justify-between">
                            <span className="font-medium">Network:</span>
                            <span className="font-medium">{getNetworkDisplayName(selectedPaymentMethod.network)}</span>
                          </div>

                          <div className='border border-b border-gray-400'></div>

                          {/* Fee info with dynamic percentage */}
                          {payment.feeChargedTo === 'customer' && payment.feeAmount > 0 ? (
                            <>
                              <div className="flex justify-between">
                                <span className="font-medium">Processing Fee:</span>
                                <span className="font-medium">{formatFeePercentage()}%</span>
                              </div>

                              <div className='border border-b border-gray-400'></div>

                              <div className="flex justify-between border-t pt-2 mt-1">
                                <span className="font-bold">Total:</span>
                                <span className="font-bold text-lg">${formatAmount(payment.totalAmount)}</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="flex justify-between">
                                <span className="font-medium">Processing Fee:</span>
                                <span className="font-medium">Included by merchant</span>
                              </div>

                              <div className='border border-b border-gray-400'></div>

                              <div className="">
                                <div className="flex justify-between">
                                  <span className="font-bold">Total:</span>
                                  <span className="font-bold text-lg">${formatAmount(payment.totalAmount)}</span>
                                </div>
                                <div className="text-xs text-gray-500 mt-1">
                                  Processing fee is covered by the merchant
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Payment Method Tabs */}
                    <div className="mb-4 px-4">
                      <div className="flex border-b border-gray-200">
                        <button
                          onClick={() => setPaymentType('wallet')}
                          className={`py-2 px-4 text-sm font-medium ${paymentType === 'wallet'
                            ? 'border-b-2 border-purple-600 text-purple-600'
                            : 'text-gray-500 hover:text-gray-700'
                            }`}
                        >
                          Connect Wallet
                        </button>
                        <button
                          onClick={() => setPaymentType('qrcode')}
                          className={`py-2 px-4 text-sm font-medium ${paymentType === 'qrcode'
                            ? 'border-b-2 border-purple-600 text-purple-600'
                            : 'text-gray-500 hover:text-gray-700'
                            }`}
                        >
                          QR Code
                        </button>
                      </div>
                    </div>

                    {/* Payment options */}
                    {testMode ? (
                      <div className="p-4 rounded-lg mb-4 bg-blue-50">
                        <div className="flex items-center">
                          <div className="bg-purple-600 rounded-full p-2 mr-3">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                          </div>
                          <div>
                            <h3 className="font-medium text-gray-800">Test Mode Payment</h3>
                            <p className="text-sm text-gray-600">Click "Pay Now" to simulate a successful payment</p>
                          </div>
                        </div>
                      </div>
                    ) : paymentType === 'qrcode' ? (
                      <div className="mb-4">
                        <QRCode
                          walletAddress={getWalletAddressForNetwork()}
                          amount={payment.totalAmount || payment.amount}
                          currency={selectedPaymentMethod.currency}
                          network={selectedPaymentMethod.network}
                          theme={theme}
                        />
                      </div>
                    ) : (
                      /* EMBEDDED WALLET INTERFACE - Replace the old wallet dropdown */
                      <EmbeddedWalletInterface 
                        onConnectWallet={onConnectWallet}
                        selectedPaymentMethod={selectedPaymentMethod}
                      />
                    )}

                    {/* Display any errors */}
                    {error && (
                      <div className="p-3 rounded-lg bg-red-50 mb-4 text-red-600 text-sm">
                        {error}
                      </div>
                    )}

                    {/* Navigation buttons */}
                    <div className="grid grid-cols-2 gap-3 mb-3 px-4">
                      <button
                        type="button"
                        onClick={onBack}
                        className="w-full py-2 px-4 bg-gray-200 hover:bg-gray-300 text-purple-600 font-medium rounded-md"
                      >
                        Back
                      </button>
                      <button
                        type="button"
                        onClick={() => onPayment(paymentType === 'qrcode')}
                        className="bg-green-600 text-white w-full py-2 px-4 font-medium rounded-md"
                        disabled={!testMode && paymentType === 'wallet' && !walletConnection}
                      >
                        {paymentType === 'qrcode' ? 'I have sent the payment' : 'Pay Now'}
                      </button>
                    </div>
                  </div>
                )}
              </ScreenTransition>

              {/* Step: Processing */}
              <ScreenTransition currentStep={step} targetStep="processing">
                <PaymentStatus
                  status="processing"
                  theme={theme}
                  message="Processing your payment..."
                  processingStartTime={processingStartTime}
                  paymentNetwork={paymentNetwork || selectedPaymentMethod?.network}
                  transactionHash={transactionHash}
                />
              </ScreenTransition>

              {/* Step: Success */}
              <ScreenTransition currentStep={step} targetStep="success">
                <PaymentStatus
                  status="success"
                  theme={theme}
                  message="Payment successful!"
                  payment={payment}
                  transactionHash={transactionHash}
                  selectedPaymentMethod={selectedPaymentMethod}
                  merchantName={merchantName}
                  onClose={handleSuccessClose}
                  pendingBackendConfirmation={pendingBackendConfirmation}
                />
              </ScreenTransition>

              {/* Step: Error */}
              <ScreenTransition currentStep={step} targetStep="error">
                <div>
                  <PaymentStatus
                    status="error"
                    theme={theme}
                    message={error || "An error occurred while processing your payment."}
                  />
                  <button
                    type="button"
                    onClick={onBack}
                    className="mt-4 w-full py-2 px-4 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-md"
                  >
                    Try Again
                  </button>
                </div>
              </ScreenTransition>
            </div>

            {/* Footer */}
            {step !== 'success' && (
              <div className="text-center text-xs text-gray-500 flex items-center justify-center gap-1 py-6 bg-white rounded-b-3xl">
                <p>Powered by <span className='text-purple-600'>Coinley</span> - Secure Cryptocurrency Payments</p>
                <svg className="inline w-4 h-4 text-green-500 ml-1" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                  <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoinleyModal;